if (!window.cuppyCart) {
  const nativeFetch = window.fetch.bind(window);
  const root = () => window.Shopify?.routes?.root || '/';
  const marker = () => document.querySelector('cuppy-cart-gift');
  const uid = () => crypto.randomUUID();
  const request = async (path, body) => {
    const response = await nativeFetch(root() + path, body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : undefined);
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'לא הצלחנו לעדכן את הסל. נסי שוב.');
    return data;
  };
  const eligible = item => item.handle === marker()?.dataset.product && !item.selling_plan_allocation && !(item.item_components || []).length;
  const units = (item, count) => Array.from({length:count},()=>({id:item.variant_id || item.id,quantity:1,properties:{...item.properties,_cuppy_unit:uid()}}));
  const normalize = async () => {
    let cart = await request('cart.js');
    for (const original of cart.items.filter(item=>eligible(item) && item.quantity>1)) {
      cart = await request('cart.js');
      const line = cart.items.find(item=>item.key===original.key) || cart.items.find(item=>item.variant_id===original.variant_id && item.quantity===original.quantity);
      if (!line) continue;
      const property = {...line.properties,_cuppy_unit:uid()};
      await request('cart/change.js',{id:line.key,quantity:1,properties:property});
      try { await request('cart/add.js',{items:units(line,line.quantity-1)}); }
      catch (error) {
        const now = await request('cart.js');
        const kept = now.items.find(item=>item.properties?._cuppy_unit===property._cuppy_unit);
        if (kept) await request('cart/change.js',{id:kept.key,quantity:line.quantity});
        throw error;
      }
    }
  };
  const finish = async () => {
    const cart = await request('cart.js');
    const sections = await request('?sections=cart-drawer,cart-icon-bubble');
    return {...cart,sections};
  };
  const gift = async (beforeCount, preferred) => {
    const cart = await request('cart.js');
    const bras = cart.items.filter(eligible);
    if (beforeCount < 2 && bras.reduce((sum,item)=>sum+item.quantity,0)===2) {
      const line = bras.find(item=>item.variant_id===Number(preferred)) || bras[0];
      await request('cart/add.js',{items:units(line,1)});
    }
  };
  let queue = Promise.resolve();
  const serial = fn => { const pending=queue.then(fn,fn); queue=pending.catch(()=>{}); return pending; };
  const pendingReplacements = new Map();
  let itemOrder = [];
  try { itemOrder = JSON.parse(sessionStorage.getItem('cuppy-cart-order') || '[]'); } catch {}
  const identity = row => row.dataset.unit || row.dataset.key;
  const rememberOrder = drawer => {
    const ids = [...drawer.querySelectorAll('.cart-items > .cart-item')].map(identity);
    itemOrder = [...itemOrder.filter(id => ids.includes(id)), ...ids.filter(id => !itemOrder.includes(id))];
    try { sessionStorage.setItem('cuppy-cart-order', JSON.stringify(itemOrder)); } catch {}
    return itemOrder;
  };
  const restoreOrder = drawer => {
    if (!drawer) return;
    rememberOrder(drawer);
    const list = drawer.querySelector('.cart-items');
    if (!list) return;
    const rows = [...list.children].filter(row => row.matches('.cart-item'));
    const ordered = [...rows].sort((a,b) => itemOrder.indexOf(identity(a)) - itemOrder.indexOf(identity(b)));
    if (ordered.some((row,index) => row !== rows[index])) ordered.forEach(row => list.append(row));
    ordered.forEach((row,index) => {
      row.querySelectorAll('cuppy-cart-options select').forEach(select => {
        select.setAttribute('aria-label', select.getAttribute('aria-label').replace(/לחזייה \d+/, `לחזייה ${index+1}`));
      });
      const pending = pendingReplacements.has(identity(row));
      row.toggleAttribute('data-variant-pending', pending);
      if (pending) row.querySelectorAll('select,button,input').forEach(control => { control.disabled = true; });
    });
    const checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout && pendingReplacements.size) checkout.disabled = true;
  };
  const renderState = (drawer, state) => {
    if (!itemOrder.length) rememberOrder(drawer);
    const active = document.activeElement;
    const focusedUnit = active?.closest('.cart-item') && identity(active.closest('.cart-item'));
    const focusedOption = active?.dataset.optionIndex;
    const scrollSelectors = ['.drawer__inner', '.cart-drawer__body', 'cart-drawer-items', '.drawer__cart-items-wrapper'];
    const scrolls = scrollSelectors.map(selector => [selector, drawer.querySelector(selector)?.scrollTop || 0]);
    drawer.renderContents(state);
    restoreOrder(drawer);
    scrolls.forEach(([selector,top]) => { const element=drawer.querySelector(selector); if(element)element.scrollTop=top; });
    if (focusedUnit && focusedOption !== undefined) {
      const row = [...drawer.querySelectorAll('.cart-item')].find(row => identity(row) === focusedUnit);
      row?.querySelector(`select[data-option-index="${focusedOption}"]`)?.focus({preventScroll:true});
    }
    drawer.classList.toggle('is-empty', state.item_count === 0);
  };
  const busy = drawer => {
    drawer?.setAttribute('aria-busy','true');
    const form=drawer?.querySelector('#CartDrawer-Form'); if(form) form.inert=true;
    const checkout=drawer?.querySelector('#CartDrawer-Checkout'); if(checkout) checkout.disabled=true;
    return ()=>{drawer?.removeAttribute('aria-busy');if(form?.isConnected)form.inert=false;if(checkout?.isConnected&&!pendingReplacements.size)checkout.disabled=false;};
  };
  const render = async drawer => {
    rememberOrder(drawer);
    const state = await finish();
    renderState(drawer,state);
  };
  const edit = (row, operation) => {
    const drawer=row.closest('cart-drawer');
    return serial(async()=>{
    const release=busy(drawer);
    try {
      const cart=await request('cart.js');
      const line=cart.items.find(item=>row.dataset.unit && item.properties?._cuppy_unit===row.dataset.unit) || cart.items.find(item=>item.key===row.dataset.key);
      if(!line) { await render(drawer); return; }
      await operation(line,cart);
      await normalize();
      await render(drawer);
    } catch(error) {
      await render(drawer);
      const errorBox=drawer.querySelector('#CartDrawer-CartErrors');if(errorBox)errorBox.textContent=error.message;
    } finally {release();}
    });
  };
  const sectionRequest = {sections:['cart-drawer','cart-icon-bubble'], sections_url:location.pathname};
  function replaceVariant(row, variant) {
    const drawer = row.closest('cart-drawer');
    const id = identity(row);
    if (pendingReplacements.has(id)) return pendingReplacements.get(id);
    rememberOrder(drawer);
    row.setAttribute('data-variant-pending','');
    row.setAttribute('aria-busy','true');
    row.querySelectorAll('select,button,input').forEach(control => { control.disabled=true; });
    const checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout) checkout.disabled=true;
    const pending = serial(async () => {
      const current = [...drawer.querySelectorAll('.cart-item')].find(item => identity(item) === id);
      if (!current) throw new Error('הסל עודכן. נסי שוב.');
      const rawProperties = JSON.parse(current.dataset.lineProperties || '{}') || {};
      const propertiesObject = Array.isArray(rawProperties) ? Object.fromEntries(rawProperties) : rawProperties;
      const line = {variant_id:Number(current.dataset.variantId), quantity:Number(current.dataset.quantity), properties:propertiesObject};
      if (line.variant_id === variant.id) return;
      const unit = line.properties._cuppy_unit || uid();
      const properties = {...line.properties,_cuppy_unit:unit};
      let replacementAdded = false;
      try {
        await request('cart/add.js',{items:[{id:variant.id,quantity:line.quantity,properties}]});
        replacementAdded = true;
        const cart = await request('cart.js');
        const original = cart.items.find(item => item.variant_id === line.variant_id && (line.properties._cuppy_unit ? item.properties?._cuppy_unit === unit : JSON.stringify(item.properties || {}) === JSON.stringify(line.properties)));
        if (!original) throw new Error('הסל עודכן. נסי שוב.');
        const state = await request('cart/change.js',{id:original.key,quantity:0,...sectionRequest});
        replacementAdded = false;
        itemOrder = itemOrder.map(value => value === id ? unit : value);
        if (!state.sections?.['cart-drawer'] || !state.sections?.['cart-icon-bubble']) state.sections = await request('?sections=cart-drawer,cart-icon-bubble');
        renderState(drawer,state);
      } catch(error) {
        const cart = await request('cart.js');
        const original = cart.items.find(item => item.variant_id === line.variant_id && (line.properties._cuppy_unit ? item.properties?._cuppy_unit === unit : JSON.stringify(item.properties || {}) === JSON.stringify(line.properties)));
        const replacement = cart.items.find(item => item.variant_id === variant.id && item.properties?._cuppy_unit === unit);
        if (replacementAdded && original && replacement) {
          const state = await request('cart/change.js',{id:replacement.key,quantity:0,...sectionRequest});
          if (state.sections?.['cart-drawer'] && state.sections?.['cart-icon-bubble']) renderState(drawer,state);
          else await render(drawer);
        } else {
          if (!original && replacement) itemOrder = itemOrder.map(value => value === id ? unit : value);
          await render(drawer);
        }
        const errorBox = drawer.querySelector('#CartDrawer-CartErrors');
        if (errorBox) errorBox.textContent = error.message;
      }
    }).finally(() => {
      pendingReplacements.delete(id);
      const current = [...drawer.querySelectorAll('.cart-item')].find(item => identity(item) === id);
      current?.removeAttribute('data-variant-pending');
      current?.removeAttribute('aria-busy');
      const options = current?.querySelector('cuppy-cart-options');
      if (options) window.cuppyLiftAvailability.sync(options,[...options.querySelectorAll('select')],JSON.parse(options.querySelector('script').textContent),false);
      current?.querySelectorAll('button,input').forEach(control => {control.disabled=false;});
      const button = drawer.querySelector('#CartDrawer-Checkout');
      if (button && !pendingReplacements.size && drawer.getAttribute('aria-busy') !== 'true') button.disabled=false;
    });
    pendingReplacements.set(id,pending);
    return pending;
  }
  window.cuppyCart={request,serial,finish,edit,normalize,units,replaceVariant,restoreOrder};
  window.fetch = function(input,init) {
    const url=new URL(typeof input==='string'||input instanceof URL?input:input.url,location.href);
    if(url.origin!==location.origin || !/\/cart\/add(?:\.js)?$/.test(url.pathname) || (init?.method||input?.method||'GET').toUpperCase()!=='POST' || !marker()) return nativeFetch(input,init);
    return serial(async()=>{
      const drawer=document.querySelector('cart-drawer');const release=busy(drawer);
      try {
        const before=await request('cart.js');
        let body;
        if(init?.body instanceof FormData || init?.body instanceof URLSearchParams) {
          body={properties:{}};const indexed=[];
          for(const [key,value] of init.body.entries()) {
            const prop=key.match(/^properties\[(.+)\]$/);
            const item=key.match(/^items\[(\d+)\]\[(id|quantity|selling_plan)\]$/);
            const itemProp=key.match(/^items\[(\d+)\]\[properties\]\[(.+)\]$/);
            if(item){indexed[Number(item[1])]||={};indexed[Number(item[1])][item[2]]=value;}
            else if(itemProp){indexed[Number(itemProp[1])]||={};indexed[Number(itemProp[1])].properties||={};indexed[Number(itemProp[1])].properties[itemProp[2]]=value;}
            else if(prop)body.properties[prop[1]]=value;else body[key]=value;
          }
          if(indexed.length)body.items=indexed.filter(Boolean);
        } else { try {body=JSON.parse(init?.body);} catch {return nativeFetch(input,init);} }
        const ids=JSON.parse(marker().dataset.variants||'[]').map(Number);
        const original=body.items||[{id:body.id,quantity:Number(body.quantity)||1,properties:body.properties||{},selling_plan:body.selling_plan}];
        body.items=original.flatMap(item=>ids.includes(Number(item.id))&&!item.selling_plan?units(item,Number(item.quantity)||1):[item]);
        delete body.id;delete body.quantity;delete body.properties;delete body.selling_plan;
        const response=await nativeFetch(url.href,{...init,headers:{...Object.fromEntries(new Headers(init?.headers)), 'Content-Type':'application/json'},body:JSON.stringify(body)});
        if(!response.ok)return response;
        const data=await response.clone().json();
        if(original.some(item=>ids.includes(Number(item.id)))) {
          try {
            await gift(before.items.filter(eligible).reduce((sum,item)=>sum+item.quantity,0),original.find(item=>ids.includes(Number(item.id)))?.id);
            await normalize();
          } catch(error) {data.cuppy_error=error.message;}
          const final=await finish();data.sections={...data.sections,...final.sections};
          if(data.cuppy_error) {
            const html=new DOMParser().parseFromString(data.sections['cart-drawer'],'text/html');
            const box=html.querySelector('#CartDrawer-CartErrors');if(box)box.textContent=data.cuppy_error;
            data.sections['cart-drawer']=html.body.innerHTML;
          }
        }
        const headers=new Headers(response.headers);headers.delete('content-length');headers.delete('content-encoding');
        return new Response(JSON.stringify(data),{status:response.status,headers});
      } finally {release();}
    });
  };
  const quantity = (row,target) => edit(row,async(line,cart)=>{
    target=Math.max(0,Math.floor(target));
    if(target>line.quantity) {
      await request('cart/add.js',{items:units(line,target-line.quantity)});
      await gift(cart.items.filter(eligible).reduce((sum,item)=>sum+item.quantity,0),line.variant_id);
    } else await request('cart/change.js',{id:line.key,quantity:target});
  });
  document.addEventListener('click',event=>{
    const button=event.target.closest('quantity-input button,cart-remove-button button');
    const row=button?.closest('#CartDrawer .cart-item');
    if(!row || row.dataset.handle!==marker()?.dataset.product)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(row.closest('cart-drawer').getAttribute('aria-busy')==='true'||row.hasAttribute('data-variant-pending'))return;
    quantity(row,button.closest('cart-remove-button')?0:Number(row.dataset.quantity)+(button.name==='plus'?1:-1));
  },true);
  document.addEventListener('change',event=>{
    const row=event.target.matches('.quantity__input')&&event.target.closest('#CartDrawer .cart-item');
    if(!row||row.dataset.handle!==marker()?.dataset.product)return;
    event.stopImmediatePropagation();
    if(Number.isFinite(Number(event.target.value)))quantity(row,Number(event.target.value));
  },true);
  customElements.define('cuppy-cart-gift',class extends HTMLElement {
    connectedCallback(){
      if(!this.closest('cart-drawer')?.querySelector('.cart-item[data-handle="'+this.dataset.product+'"][data-multiple="true"]'))return;
      serial(async()=>{const drawer=this.closest('cart-drawer');if(!drawer)return;const release=busy(drawer);try{await normalize();await render(drawer);}catch(error){const box=drawer.querySelector('#CartDrawer-CartErrors');if(box)box.textContent=error.message;}finally{release();}});
    }
  });
}

if (!customElements.get('cuppy-checkpoint-context')) {
  customElements.define('cuppy-checkpoint-context', class extends HTMLElement {
    connectedCallback() {
      const handle = decodeURIComponent(location.pathname).match(/\/products\/([^/]+)/)?.[1];
      const promotion = handle === this.dataset.page || Number(this.dataset.count) > 0;
      this.querySelector('[data-cuppy-promotion]').hidden = !promotion;
      this.querySelector('[data-cuppy-standard]').hidden = promotion;
    }
  });
}

if (!customElements.get('cuppy-cart-suggestion')) {
  const drawerStates = new WeakMap();
  const stateFor = drawer => {
    if (!drawerStates.has(drawer)) {
      const state = { open: drawer.classList.contains('active'), shown: new Set() };
      state.observer = new MutationObserver(() => {
        const open = drawer.classList.contains('active');
        if (!open && state.open) state.shown.clear();
        state.open = open;
      });
      state.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      drawerStates.set(drawer, state);
    }
    return drawerStates.get(drawer);
  };
  customElements.define('cuppy-cart-suggestion', class extends HTMLElement {
    connectedCallback() {
      const handle = decodeURIComponent(location.pathname).match(/\/products\/([^/]+)/)?.[1];
      const onPromotionPage = handle === this.dataset.page || Number(this.dataset.count) > 0;
      this.hidden = this.dataset.mode === 'fallback' ? onPromotionPage : !onPromotionPage;
      if (this.hidden) return;
      this.drawer = this.closest('cart-drawer');
      if (!this.drawer) return;
      this.state = stateFor(this.drawer);
      this.key = this.dataset.mode + ':' + [...this.querySelectorAll('[data-product-id]')].map(el => el.dataset.productId).join(',');
      this.updateReveal = () => {
        clearTimeout(this.revealTimer);
        if (this.state.shown.has(this.key) && this.drawer.classList.contains('active')) {
          this.classList.remove('cuppy-cart-suggestion--pending');
          this.inert = false;
          return;
        }
        this.classList.remove('cuppy-cart-suggestion--enter');
        this.classList.add('cuppy-cart-suggestion--pending');
        this.inert = true;
        if (!this.drawer.classList.contains('active') || this.drawer.dataset.cuppyGiftUpdating === 'true' || this.drawer.getAttribute('aria-busy') === 'true') return;
        this.revealTimer = setTimeout(() => {
          if (!this.isConnected || !this.drawer.classList.contains('active')) return;
          this.state.shown.add(this.key);
          this.inert = false;
          this.classList.remove('cuppy-cart-suggestion--pending');
          this.classList.add('cuppy-cart-suggestion--enter');
        }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260);
      };
      this.observer = new MutationObserver(this.updateReveal);
      this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class', 'aria-busy', 'data-cuppy-gift-updating'] });
      this.updateReveal();
    }
    disconnectedCallback() {
      clearTimeout(this.revealTimer);
      this.observer?.disconnect();
    }
  });
}

if (!customElements.get('cuppy-cart-options')) {
  customElements.define('cuppy-cart-options',class extends HTMLElement {
    connectedCallback(){
      this.selects=[...this.querySelectorAll('select')];
      this.variants=JSON.parse(this.querySelector('script').textContent);
      this.previous=JSON.parse(this.dataset.selectedOptions);
      this.selects.forEach((select,index)=>{select.value=this.previous[index];});
      const variant=window.cuppyLiftAvailability.sync(this,this.selects,this.variants,false);
      this.querySelector('[role="status"]').textContent=variant?'':'הפריט שבסל אינו זמין כרגע. בחרי מידה וצבע זמינים.';
      this.onChange ||= event=>{
        if(event.target.tagName!=='SELECT')return;
        event.stopPropagation();
        if(!this.pending)this.changeVariant(event.target);
      };
      this.addEventListener('change',this.onChange);
      queueMicrotask(()=>window.cuppyCart.restoreOrder(this.closest('cart-drawer')));
    }
    disconnectedCallback(){this.removeEventListener('change',this.onChange);}
    changeVariant(select){
      const availability=window.cuppyLiftAvailability;
      const {color}=availability.positions(this);
      const variant=availability.sync(this,this.selects,this.variants,select===this.selects[color]);
      if(!variant){
        this.querySelector('[role="status"]').textContent='בחרי מידה וצבע זמינים כדי לעדכן את הפריט.';
        return;
      }
      this.querySelector('[role="status"]').textContent='';
      if(variant.options.every((value,index)=>value===this.previous[index]))return;
      this.pending=true;
      this.selects.forEach(select=>{select.disabled=true;});
      const row=this.closest('.cart-item');const api=window.cuppyCart;
      const colorValue=variant.options[color];
      const config=document.getElementById('cuppy-lift-media-config');
      const images=config?JSON.parse(config.textContent):{};
      const image=row.querySelector('.cart-item__image');
      const previousImage=image?.getAttribute('src');
      const imageKey={'שחור':'black','בז׳':'beige','מוקה':'mocha'}[colorValue];
      if(image&&images[imageKey]){image.removeAttribute('srcset');image.src=images[imageKey];image.alt=colorValue;image.dataset.cuppyColor=colorValue;}
      api.replaceVariant(row,variant).catch(error=>{
        if(this.isConnected){
          this.selects.forEach((select,index)=>{select.value=this.previous[index];});
          if(image&&previousImage)image.src=previousImage;
          this.querySelector('[role="status"]').textContent=error.message||'לא הצלחנו לעדכן את הפריט. נסי שוב.';
        }
      }).finally(()=>{
        this.pending=false;
        if(this.isConnected)availability.sync(this,this.selects,this.variants,false);
      });
    }
  });
}
